import { GlobalState } from '@leverege/ui-redux';
import { InterfaceReducer } from '@leverege/api-redux';
import { matchPath } from 'react-router';
import ItemDelegate from "./ItemDelegate.js";
import Relationship from "../Relationship.js";
import ImagineRelationship from "./ImagineRelationship.js";
let lastRel = null;
let relationships = [];

/**
 * The Ref for the objects belonging to this data source should
 * look like ':systemId/path_to_parent', The 'id' from the object
 * will be used to get the final action object. This minimizes
 * string construction for each unique path.
 */
export default class BlueprintDataSource {
  constructor(blueprint) {
    this.blueprint = blueprint;
  }
  dataSource() {
    return this.blueprint.name;
  }
  getData(objRef) {
    const state = GlobalState.get();
    return state.models.lookup[objRef.id] || InterfaceReducer.getObject(state, `${objRef.ref}/${objRef.id}`);
  }
  getActions(objRef) {
    const rel = BlueprintDataSource.getRelationship(objRef);
    if (rel != null) {
      // rel is { match, relationship }
      return new ItemDelegate({
        match: rel.match,
        relationship: rel.relationship.createResolved(rel.match)
      });
    }
    return null;
  }

  /**
   * Returns { relationship, match } for the given objectRef. Rel will be the
   * relationship for the object, and match will be the extracted
   * ids of the parents. This will return null if there is not a matching
   * relationship
   */
  static getRelationship(objRef) {
    const {
      id,
      ref
    } = objRef;
    return getRelationshipFor(`${ref}/${id}`);
  }
}
function getRelationshipFor(ref) {
  if (lastRel !== Relationship.getAll()) {
    lastRel = Relationship.getAll();

    // rebuild relationships on a change
    relationships = lastRel.filter(rel => rel instanceof ImagineRelationship).map(rel => {
      // const r = Relationship.createItemRelationship( rel ) 
      const r = rel.createItem();
      const lastSegment = r.objRefUrlPath.substring(r.objRefUrlPath.lastIndexOf('/') + 1);
      const match = {
        path: lastSegment.includes(':') ? r.objRefUrlPath : r.objRefUrlPath.replace(lastSegment, `:${lastSegment}Id`),
        exact: true,
        strict: true
      };
      return {
        match,
        relationship: r
      };
    });
    sort();
  }
  for (let n = 0; n < relationships.length; n++) {
    const rel = relationships[n];
    const match = matchPath(ref, rel.match);
    if (match) {
      return {
        match,
        relationship: rel.relationship
      };
    }
  }
  return null;
}
function sort() {
  relationships.sort((a, b) => {
    return a.relationship.objRefUrlPath.localeCompare(b.relationship.objRefUrlPath);
  });
}